export default {
    monitor: {name: "Monitor"},
    keyboard: {name: "Teclado"},
    mouse: {name: "Rato"},
    webcam: {name: "Webcam"},
    headset: {name: "Fone de ouvido"},
    dockingStation: {name: "Estação de acoplamento"},
}